export default __webpack_public_path__ + "static/about-bg-cc70de92c7905f3743e9c6caff861c96.webp";